<script>
  import TextPage from "./TextPage.svelte";
  import Paragraph from "./Paragraph.svelte";
  import Header from "./Header.svelte";
  import ExternalLink from "./ExternalLink.svelte";
  import {
    ENDAOMENT_URL,
    GENERATIVE_FILM_URL,
    LINK_EDITIONS,
  } from "../util/constants";
  import LinkButton from "./LinkButton.svelte";
  import RoundLinkButton from "./RoundLinkButton.svelte";
  import PunchLoopVideo from "./PunchLoopVideo.svelte";
</script>

<TextPage>
  <Header>Other Ways to Donate</Header>
  <Paragraph>
    You can also donate directly to the <ExternalLink
      href={GENERATIVE_FILM_URL}
      italic>Generative</ExternalLink
    > film production via <ExternalLink href={ENDAOMENT_URL}
      >Endaoment</ExternalLink
    >.</Paragraph
  >
  <div class="button-container">
    <RoundLinkButton href={ENDAOMENT_URL} external text="DONATE"
    ></RoundLinkButton>
  </div>
  <Paragraph
    >This allows for a range of payment methods including debit, credit, Apple
    Pay, and alternative crypto currencies. Contributions will be handled by the
    fiscal sponsor <ExternalLink
      href="https://www.thefilmcollaborative.org/fiscalsponsorship/projects/generative"
      >The Film Collaborative</ExternalLink
    >. Note that donations made this way will not count toward the <LinkButton
      to={`/${LINK_EDITIONS}`}
      inline>32 Bit Edition</LinkButton
    > rankings and NFT minting.
  </Paragraph>
  <Paragraph
    >Because Endaoment and The Film Collaborative are both 501(c)(3) non-profit
    charities, direct donations to the film through this method are tax
    deductible in the USA.</Paragraph
  >

  <PunchLoopVideo></PunchLoopVideo>
</TextPage>

<style>
  .button-link {
    text-decoration: none;
    font-weight: inherit;
  }
  .button-container {
    padding: 20px;
    padding-left: 0;
  }
</style>
